import * as WarningModal from './components/WarningModal.css';

export default {
	WarningModal
};
